import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Link } from "react-router-dom";
import { Bookmark, ArrowUpRight } from "lucide-react";

const fmtMoney = (n) => n == null ? "—" : `$${Number(n).toLocaleString(undefined, { maximumFractionDigits: 0 })}`;

export default function Saved() {
  const [grants, setGrants] = useState([]);

  useEffect(() => { api.get("/grants/saved/list").then((r) => setGrants(r.data.grants || [])); }, []);

  return (
    <div className="space-y-8" data-testid="saved-page">
      <header>
        <div className="label-eyebrow mb-2">Bookmarks</div>
        <h1 className="font-heading font-light text-4xl md:text-5xl tracking-tighter">Saved grants</h1>
        <p className="text-[#5E5E5E] mt-2">The grants you're keeping close.</p>
      </header>

      {grants.length === 0 ? (
        <div className="bg-white border border-[#E6E4DF] rounded-lg py-24 text-center text-[#5E5E5E]">
          Nothing saved yet. <Link className="text-[#1C3F35] underline" to="/grants">Discover grants</Link>.
        </div>
      ) : (
        <ul className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
          {grants.map((g) => (
            <li key={g.id} data-testid={`saved-${g.id}`} className="bg-white border border-[#E6E4DF] rounded-lg p-6">
              <div className="flex items-center justify-between">
                <span className="label-eyebrow">{g.category || "Grant"}</span>
                <Bookmark className="w-4 h-4 text-[#1C3F35]" fill="currentColor"/>
              </div>
              <Link to={`/grants/${g.id}`} className="mt-3 block font-heading text-lg font-medium text-[#1A1A1A] hover:text-[#1C3F35] line-clamp-2">
                {g.title}
              </Link>
              <div className="mt-2 text-xs text-[#5E5E5E]">{g.agency}</div>
              <div className="mt-4 flex items-center justify-between text-xs text-[#5E5E5E]">
                <span>{fmtMoney(g.funding_max || g.funding_min)}</span>
                <Link to={`/grants/${g.id}`} className="text-[#1C3F35] inline-flex items-center gap-1">Open <ArrowUpRight className="w-3 h-3"/></Link>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
